export default function PromiseByTeam() {
  return (
    <section id="experience">
  <div class="experience-inner">
    <div class="sec-label">Our Promise</div>
    <p class="exp-quote">
      "Big dreams, <em>real budgets.</em> We believe the most beautiful events are the ones that feel<em> truly yours</em> — not just expensive."
    </p>
    <div class="exp-attr">— Abhinav &amp; Charan, Founders</div>
  </div>
</section>
  );
}